import { CMSResource } from "app/resources/cmsresource";

export class FooterCopyRightResource extends CMSResource {

    id: number;

    textFr: string;

    textRo: string;

    textEn: string;

    textDe: string;

    backgroundColor: string;

    textColor: string;
    
    userEmail:string
}